@if (!edit) {
  <h1 mat-dialog-title>Thema erstellen</h1>
}
@if (edit) {
  <h1 mat-dialog-title>Thema bearbeiten</h1>
}
<mat-dialog-content class="custom-scrollbar w800">
  <form [formGroup]="sysGrammarFormGroup" class="pad-top8">
    <mat-form-field appearance="outline" class="w49 marg-right2">
      <mat-label>Name</mat-label>
      <input formControlName="nameCtrl" matInput placeholder="" required>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w49 clickable" (click)="selectSystemicGrammarCategory()">
      <mat-label>Überthema</mat-label>
      <mat-select formControlName="parentCtrl" multiple placeholder="">
        @for (option of [selectedParentCategory]; track option) {
          <mat-option [value]="option?.id">
            {{ option?.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-raised-button>Abbrechen</button>
  <button (click)="saveOrCreateCategory()" [disabled]="sysGrammarFormGroup.controls.nameCtrl.hasError('required')"
    color="primary"
    mat-raised-button>Speichern
  </button>
</mat-dialog-actions>
